import React, { useState, useEffect } from 'react';

import { convertNumberToPrecision } from 'src/components/JobDatasheet/utils';
import { QuestionNumberDefaultProps, QuestionNumberPropTypes } from 'src/components/JobDatasheet/propTypes';
import { noop } from 'src/utils/core/event';
import { sanitizeQuestionResult } from 'src/utils/helpers';
import { EiqInput } from 'eiq-storybook';
import s from 'src/components/JobDatasheet/JobDatasheetForm/JobDatasheetForm.styles';

export const QuestionNumber = ({
  errors,
  flash,
  isRectifiedQuestion,
  onChange,
  question: {
    numberSettings: { precision, removeDecimalLimitation },
    id
  },
  readonly,
  value,
  disableChange,
}) => {
  const selectedValueKey = isRectifiedQuestion ? 'rectifiedValue' : 'value';
  const [localValue, setLocalValue] = useState('');
  useEffect(() => {
    setLocalValue(value);
  }, [value?.value, value?.rectifiedValue]);

  let numberValue = (localValue || { value: '' })[selectedValueKey];
  if (numberValue === undefined) {
    numberValue = '';
  }

  const getReturnObject = val => {
    const result = { type: 'number', value: val };
    const sanitizedVal = sanitizeQuestionResult(result, result.type)?.value || val;
    const returnObject = {
      ...value,
      type: 'number'
    };
    const precisionValue = removeDecimalLimitation ? 1000 : precision;
    returnObject[selectedValueKey] = convertNumberToPrecision(sanitizedVal, precisionValue);

    return returnObject;
  };

  return (
    <s.QuestionNumberPercentTimeWrapper>
    <EiqInput
    errorMessage={(errors || []).join(' & ')}        
    type='number'
    onBlur={!disableChange ? () => {
      if (!readonly && (localValue?.value !== value?.value)) {
        onChange(localValue);
      }
    } : noop}
    defaultValue={value}
    id={`question-number-input-${id}`}
    wrapperClassName={'eiqInput'}
    onChange={!disableChange ? (e) => {
      setLocalValue(getReturnObject(e.target.value));
    } : noop}
    value={numberValue || ''}
    />
    </s.QuestionNumberPercentTimeWrapper>
  );
};

QuestionNumber.propTypes = QuestionNumberPropTypes;
QuestionNumber.defaultProps = QuestionNumberDefaultProps;
